import {
  ExchangeRecommendationsSchema,
  GenerateExchangeRecommendationsInputSchema,
} from "@redotech/redo-model/agents/returns-agents/exchange-recommendations";

export const getExchangeRecommendations = {
  input: GenerateExchangeRecommendationsInputSchema,
  output: ExchangeRecommendationsSchema,
};
